import _ from 'lodash'

const mixinMethods = {
  methods: {
    mapUpsellingMixinMethod: function (upselling, tripSegment) {
      const { fares, fares_information } = this.availability
      return _.filter(
        _.mapValues(upselling, (upsellingFfam, ffamKey) => {
          const { fare_key, next_flight_fares } = upsellingFfam
          let actualFareInformation = _.cloneDeep(fares[fare_key])
          if (actualFareInformation) {
            const rbdForSegment = _.get(actualFareInformation, [
              'rbd',
              tripSegment,
            ])
            if (rbdForSegment) {
              actualFareInformation.rbd = rbdForSegment
            }
            this.orderServices(
              actualFareInformation.trip_segment_services[tripSegment]
            )
          }
          return {
            fare_key: `${fare_key}-T${tripSegment}`,
            next_flight_fares,
            ...fares_information[ffamKey],
            fare_information: actualFareInformation,
          }
        }),
        (item) => item.fare_information
      ).sort(
        (a, b) =>
          a.fare_information.trip_segment_prices[tripSegment].total -
          b.fare_information.trip_segment_prices[tripSegment].total
      )
    },
    orderServices: function (services) {
      return services.sort((a, b) => {
        const order = { free: 1, charges_apply: 2, not_included: 3 }
        return order[a.condition] - order[b.condition]
      })
    },
    scrollToRefMixinMethod: function (refName, offset, timeout) {
      setTimeout(() => {
        const refElement = this.$refs[refName][0].$el
        if (refElement) {
          const elementPosition =
            refElement.getBoundingClientRect().top + window.scrollY
          const offsetPosition = elementPosition + offset
          window.scrollTo({ top: offsetPosition, behavior: 'smooth' })
        }
      }, timeout)
    },
    parseAirportInformationMixinMethod: function (
      journey,
      airportsInformation
    ) {
      if (!journey.airportInformationParsed) {
        for (const key in journey) {
          if (key === 'arrival' || key === 'departure') {
            const airportReferenceId = journey[key].airport_reference_id
            journey[key] = {
              ...journey[key],
              ...airportsInformation[airportReferenceId],
            }
          } else if (key === 'flight_detail' || key === 'stops_details') {
            for (const segment of journey[key]) {
              this.parseAirportInformationMixinMethod(
                segment,
                airportsInformation
              )
            }
          }
        }
        journey.airportInformationParsed = true
      }
    },
  },
}

export default mixinMethods
